import script from "./ImagePreviewModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ImagePreviewModal.vue?vue&type=script&setup=true&lang=js"

import "./ImagePreviewModal.vue?vue&type=style&index=0&id=5b355724&lang=scss"

const __exports__ = script;

export default __exports__